<template>
  <layout-basic>
    <section class="banner-text padding-bottom why-improve">
      <v-row no-gutters>
        <v-col class="banner-wrapper">
          <!-- Shape Background -->
          <div class="cyber-security-shape-background">
            <img
              class="cyber-security-background-image border-bottom"
              :src="
                getImageSource(
                  'improve-main-banner-gradient-background.png',
                  'homepage/banner'
                )
              "
            />
            <img
              v-if="screenSize === 'desktop'"
              class="cyber-security-banner-blue-image"
              :src="
                getImageSource(
                  'online-cyber-security-training-blue-shape.png',
                  'courses/cyber-security'
                )
              "
            />
            <img
              v-if="screenSize === 'desktop'"
              class="cyber-security-banner-white-image"
              :src="
                getImageSource(
                  'online-cyber-security-training-grey-shape.png',
                  'courses/cyber-security'
                )
              "
            />
          </div>
          <v-container class="banner-img-text-wrapper pb-0">
            <!-- Banner Left Wrapper -->
            <div class="cyber-security-banner-left-wrapper">
              <div id="main-banner-wrapper">
                <img
                  class="cyber-security-rounded-rectangle-image"
                  :src="
                    getImageSource(
                      'main-banner-rounded-rectangle.png',
                      'homepage/banner'
                    )
                  "
                />
                <div class="banner-text-overlay">
                  CYBER ESSSENTIALS TRAINING
                </div>
              </div>
              <div class="cyber-security-banner-main-title">
                Protect Your Organisation and Employees with Online Cyber
                Security Training
              </div>
              <div class="banner-sub-text" style="margin-bottom: 20px;">
                Our Cyber Essentials training course keeps your staff safe
                online and offline.
              </div>
            </div>

            <!-- Microlearning Image -->
            <free-trial-form />
          </v-container>
        </v-col>
      </v-row>
    </section>
    <section class="improve-customers">
      <v-row class="text-center margin-top-75" no-gutters>
        <v-container style="padding: 0 25px">
          <div class="carousel-title">
            Organisations across multiple sectors using IMPROVE
          </div>
          <v-col class="pa-0" cols="12" md="12" p>
            <VueSlickCarousel v-bind="imageCarousel">
              <template #prevArrow="arrowOption">
                <div class="custom-carousel-button">
                  <span><i class="fa fa-chevron-left"></i></span>
                </div>
              </template>
              <template #nextArrow="arrowOption">
                <div class="custom-carousel-button">
                  <span><i class="fa fa-chevron-right"></i></span>
                </div>
              </template>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/advoacy-focus.png"
                  class="img-fluid"
                  alt="Advocacy Focus Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/east-midlands-chamber.png"
                  class="img-fluid"
                  alt="East Midlands Chamber Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/eden-holistic-pet-foods.png"
                  class="img-fluid"
                  alt="Eden Holistic Pet Foods Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/effectech.png"
                  class="img-fluid"
                  alt="Effectech Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/hr-central-human-resources-consultancy.jpg"
                  class="img-fluid"
                  alt="HR Central Human Resources Consultancy Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/hope-nottingham.png"
                  class="img-fluid"
                  alt="Hope Nottingham Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/la-micro.png"
                  class="img-fluid"
                  alt="La Micro Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/laceys-solicitors.png"
                  class="img-fluid"
                  alt="Laceys Solicitors Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/m-j-r.png"
                  class="img-fluid"
                  alt="M J R Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/people-value.png"
                  class="img-fluid"
                  alt="People Value Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/pilkington.png"
                  class="img-fluid"
                  alt="Pilkington Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/tevva.png"
                  class="img-fluid"
                  alt="Tevva Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/APK_Group_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="APK Group Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/3SC_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="3SC Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Advonet_Group_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="Advonet Group Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Boostwork_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="Boostwork Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/BPX_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="BPX Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Carter_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="Carter Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/China-Britain-Business-Council-IMPROVE-Customer.png"
                  class="img-fluid"
                  alt="China Britain Business Council Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Council-of-Deans-of-Heath-IMPROVE-Customer.png"
                  class="img-fluid"
                  alt="Council of Deans of Health Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Devon-Community-Foundation-IMPROVE-Customer.jpg"
                  class="img-fluid"
                  alt="Devon Community Foundation Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/IP-Group-IMPROVE-Customer.png"
                  class="img-fluid"
                  alt="IP Group Approved IMPROVE partner"
                />
              </div>
            </VueSlickCarousel>
          </v-col>
        </v-container>
      </v-row>
    </section>
    <hr />
    <section style="margin-top: 40px;">
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container>
            <div class="cyber-title text-center">
              <h2>Cyber Security:</h2>
              <h2 style="margin-bottom: 15px;">
                Essential Training for Businesses
              </h2>

              <span
                >Around half of all cyber attacks target small-to-medium-sized
                businesses (SMEs) globally.</span
              >

              <p>
                SMEs are often less equipped to deal with the dangers of cyber
                threats than larger organisations, which is why the right cyber
                security is essential for smaller companies.
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col
          cols="12"
          align-self="center"
          no-gutters
          style="position: relative;"
        >
          <img
            v-if="screenSize === 'desktop'"
            class="cyber-training-overlay-right"
            src="/static/courses/cyber-security/cyber-security-training-yellow-shape.png"
          />

          <img
            v-if="screenSize === 'desktop'"
            class="cyber-training-overlay-left"
            src="/static/courses/cyber-security/cyber-security-training-pink-shape.png"
          />
          <v-container style="padding: 0 15px">
            <div class="cyber-training-wrapper">
              <div class="cyber-training-content">
                <h1>Upload Your Own Documents</h1>

                <span
                  >This course introduces cyber security and your role in
                  keeping your business secure. It includes:</span
                >

                <div style="color: #333333">
                  <i
                    class="fa fa-check"
                    style="color: #08a0a8 !important; margin-right: 5px;"
                  ></i>
                  An introduction to cyber security
                </div>
                <div style="color: #333333">
                  <i
                    class="fa fa-check"
                    style="color: #08a0a8 !important;margin-right: 5px;"
                  ></i>
                  Definitions of words and phrases relating to cyber security
                </div>
                <div style="color: #333333">
                  <i
                    class="fa fa-check"
                    style="color: #08a0a8 !important;margin-right: 5px;"
                  ></i>
                  Threats and vulnerabilities in cyber security for SMEs
                </div>
                <div style="color: #333333">
                  <i
                    class="fa fa-check"
                    style="color: #08a0a8 !important;margin-right: 5px;"
                  ></i>
                  How employees can help to keep their organisation safe.
                </div>

                <p>
                  The course includes videos to learn from and a workbook to
                  complete, giving your staff an introduction to cyber safety
                  and a basis to continue their learning.
                </p>
                <a
                  :href="experienceHref"
                  class="course-library-btn"
                  rel="noopener"
                >
                  Experience IMPROVE
                </a>
              </div>
              <img
                class="cyber-training-image"
                :src="
                  getImageSource(
                    'cyber-security-training-courses.png',
                    'courses/cyber-security'
                  )
                "
              />
            </div>
          </v-container>
        </v-col>
      </v-row>
    </section>
    <section style="padding-bottom: 70px; margin-top: 100px;">
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container style="padding: 0 15px;">
            <div class="more-benefit-title text-center mt-15">
              <img
                src="/static/homepage/choose/why-choose-improve-for-your-business.png"
              />

              <h2>The Complete Microlearning</h2>
              <h2>Platform for Businesses</h2>

              <p>
                We’ve designed our training platform with small-to-medium-sized
                businesses in mind.
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-container class="choose-cards">
        <v-row class="choose-cards">
          <v-col cols="12" sm="12" md="4">
            <div class="training-card">
              <h2>Get Instant Access to <span>100+ Online Courses</span></h2>
              <p>
                Access <b>more than 100 off-the-shelf courses</b> on desktop,
                tablet and mobile. Courses include
                <b>Cyber Security, ePrivacy</b> for Business Owners and more.
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>
          <v-col cols="12" sm="12" md="4">
            <div class="scalable-card">
              <h2><span>All-in-One</span> Training Solution</h2>
              <p>
                <b>Induct new starters,</b> develop your people and
                <b>manage compliance,</b> all on one platform.
                <b>IMPROVE</b> puts you in control of your organisation’s
                training.
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>
          <v-col cols="12" sm="12" md="4">
            <div class="dedicated-card">
              <h2><span>Personalise</span> Your Company Training</h2>
              <p>
                <b>Add your own courses</b> and
                <b>content, track training progress</b> and log users’
                achievements to <b>empower your employees.</b>
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>

          <v-col cols="12" sm="12" md="4">
            <div class="courses-card">
              <h2>
                <span>Simple and Affordable Pricing</span> for Small Businesses
              </h2>
              <p>
                Get a <b>tailored online training solution</b> for your
                organisation
                <b>without paying a premium. Flexible yearly billing</b> is
                available.
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>

          <v-col cols="12" sm="12" md="4">
            <div class="cost-card">
              <h2>Start a <span>FREE 14 Day Trial</span></h2>
              <p>
                <b>Want to try before you buy?</b> Get full access to
                <b>100+ courses</b> when you start your free trial.
                <b>No payment details are required.</b>
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>

          <v-col cols="12" sm="12" md="4">
            <div class="platform-card">
              <h2><span>Dedicated</span> Customer Support</h2>
              <p>
                From <b>implementation</b> to <b>ongoing support, </b>we're here
                to assist you at <b>every step.</b>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <hr />
    <section style="margin-top: 50px;">
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container>
            <div class="testimonial-title text-center">
              <h2>Customer Testimonials</h2>
              <p>
                We’ve helped hundreds of businesses take control of their
                organisation’s training. Hear what they have to say about us
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-container>
        <VueSlickCarousel v-bind="testimonialCarousel">
          <div class="testimonial-item">
            <div class="testimonial-card">
              <div>
                <h2>“Flexible and Limitless”</h2>
                <p>
                  “The system is like no other in the market. HRCentral Limited 
                  and our clients are continually impressed by the user-friendly, 
                  flexible and limitless training opportunities IMPROVE can offer.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/hr-central-human-resources-consultancy.jpg"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
                src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
                class="testimonial-placeholder-circle"
              /> -->
            <div class="testimonial-card">
              <div>
                <h2>“The Best Onboarding Process”</h2>
                <p>
                  “New staff have been in ‘awe’ of our onboarding process which
                  is all centrally delivered via IMPROVE. We have found it to be
                  the best onboarding process we have experienced.”
                </p>
              </div>

              <img
                src="/static/homepage/testimonial/advocacy-focus-testimonial.png"
                alt="Advocacy Focus Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
                src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
                class="testimonial-placeholder-circle"
              /> -->
            <div class="testimonial-card">
              <div>
                <h2>“Comprehensive & Easy to Access”</h2>
                <p>
                  “It’s authoritative, accurate, comprehensive, and easy to
                  access. It removes the stress of training delivery from
                  business owners, knowing that they can review what their staff
                  are learning.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/smart-space-testimonial.png"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <div class="testimonial-card">
              <div>
                <h2>“Consistently Impressed”</h2>
                <p>
                  “As a proud partner of IMPROVE, we have been consistently impressed with the 
                  customer service and support we have received from the team. They are responsive, 
                  go out of their way to help, and adapt to support our needs and growth as a HR 
                  consultancy, which in turn supports our clients.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/hr-central-human-resources-consultancy.jpg"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
                src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
                class="testimonial-placeholder-circle"
              /> -->
            <div class="testimonial-card">
              <div>
                <h2>“Seamless Training Process”</h2>
                <p>
                  “The user-friendly interface has been built to ensure that
                  everyone can use it with ease, and the courses are tailored to
                  suit each team member's learning needs.”
                </p>
              </div>

              <img
                src="/static/homepage/testimonial/eden-holistic-pet-foods-testimonial.png"
                alt="Eden Holistic Pet Foods Approved IMPROVE partner"
              />
            </div>
          </div>
        </VueSlickCarousel>
      </v-container>
    </section>
    <section class="animate-cat-on-scroll">
      <v-row no-gutters>
        <v-col no-gutters>
          <!-- Shape Background -->
          <div class="faq-cyber-background">
            <img
              class="demo-background-cat"
              :src="
                getImageSource(
                  'training-courses-for-smes-with-improve.png',
                  'homepage/demo'
                )
              "
            />
            <div class="faq-cyber-panel"></div>

            <div class="faq-content">
              <h2 style="color: #ffffff !important;">
                Frequently Asked Questions
              </h2>
              <p style="color: #E7F8FF !important;">
                Every company’s needs are different, so we’ve included some of
                our most frequently asked questions about the course and our
                platform below.
              </p>
              <v-expansion-panels
                accordion
                class="faq-expansion-panel"
                v-model="expandedPanel"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >Is the Cyber Essentials course right for my business?
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    Most likely, yes! It’s vital that businesses of all sizes
                    educate their staff on the dangers of cyber threats and how
                    to protect themselves online and offline. It’s worth noting
                    that Small to Medium sized businesses are particularly
                    vulnerable to cyber attacks due to limited resources.
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <div style="height: 20px; width: 100%;"></div>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >What does the Cyber Essentials training course cover?
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      style="color: rgba(0, 0, 0, 0.87); margin-bottom: 10px"
                    >
                      This course will introduce you to cyber security and give
                      you information on how to keep your business safe online.
                    </div>

                    <div style="color: rgba(0, 0, 0, 0.87)">
                      &bull; To learn what Cyber Security is and the different
                      names it has
                    </div>

                    <div style="color: rgba(0, 0, 0, 0.87)">
                      &bull; To learn the definitions of key words and phrases
                      related to cyber security
                    </div>

                    <div style="color: rgba(0, 0, 0, 0.87)">
                      &bull; To learn how employees can help to keep an
                      organisation safe
                    </div>

                    <div style="color: rgba(0, 0, 0, 0.87)">
                      &bull; To learn about the different threats and
                      vulnerabilities in cyber security
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <div style="height: 20px; width: 100%;"></div>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >Do you offer more courses in cyber security and online
                    privacy?
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    Yes
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <div style="height: 20px; width: 100%;"></div>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >Do I need to enter credit card details before I can access
                    the courses?
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    No
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <div style="height: 20px; width: 100%;"></div>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >How much does the course cost?
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    The course is free for 14 days, after which you can choose
                    from our flexible
                    <a style="color: #08a0a8;" href="/pricing">pricing plans</a
                    >.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>
    <section>
      <v-row no-gutters>
        <v-col no-gutters>
          <!-- Shape Background -->
          <div class="demo-background" style="    margin-top: 0px !important;">
            <img
              class="demo-background-image"
              :src="
                getImageSource(
                  'improve-cyber-security-contact-form-bg.png',
                  'courses/cyber-security'
                )
              "
            />
            <div class="demo-content">
              <h2 style="color: #002458 !important;">
                Become Cyber-Safe with IMPROVE Online
              </h2>
              <p style="color: #002458 !important;">
                Protect your staff and your organisation with our online Cyber
                Essentials training course today.
              </p>
              <a
                :href="experienceHref"
                class="book-demo-btn"
                style="max-width: 230px !important"
                rel="noopener"
              >
                Experience IMPROVE
              </a>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import { screensize } from '../../utils/screensize';
import FreeTrialForm from '../../components/FreeTrialForm.vue';
import { IMPROVE_CONFIG } from '@/config.js';
import { getExperienceHref } from '@/config/ctas';
// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'CyberSecurity',
  metaInfo() {
    return {
        title: "Cyber Security Training: Protect Your SME with IMPROVE Courses",
        meta: [
            // Meta Description
            { name: 'description', content: "Equip your team with essential cyber security skills using IMPROVE's microlearning courses. Protect your SME against cyber threats with affordable, effective training." },
            
            // Keywords
            { name: 'keywords', content: "cyber security training, SME cyber security, online cyber security courses, IMPROVE microlearning, cyber threat protection, employee cyber training" },
            
            // Open Graph / Facebook Tags
            { property: 'og:title', content: "Cyber Security Training: Protect Your SME with IMPROVE Courses" },
            { property: 'og:description', content: "Equip your team with essential cyber security skills using IMPROVE's microlearning courses. Protect your SME against cyber threats with affordable, effective training." },
            { property: 'og:image', content: "https://www.improve.online/static/SEO.png" },
            { property: 'og:type', content: 'website' },
            { property: 'og:url', content: 'https://www.improve.online/courses/cyber-security' },

            // Twitter Card Tags
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: "Cyber Security Training: Protect Your SME with IMPROVE Courses" },
            { name: 'twitter:description', content: "Equip your team with essential cyber security skills using IMPROVE's microlearning courses. Protect your SME against cyber threats with affordable, effective training." },
            { name: 'twitter:image', content: "https://www.improve.online/static/SEO.png" }
        ],
        link: [
            // Canonical URL
            { rel: 'canonical', href: 'https://www.improve.online/courses/cyber-security' }
        ]
      };
  },
  components: {
    LayoutBasic,
    VueSlickCarousel,
    FreeTrialForm,
  },
  data() {
    return {
      expandedPanel: 0,
      screenSize: currentScreenSize,
      imageCarousel: {
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 599,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      testimonialCarousel: {
        infinite: true,
        autoplay: true,
        dots: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      directUrl: IMPROVE_CONFIG.DIRECT_URL,
    };
  },
  computed: {
    experienceHref() {
      return getExperienceHref();
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    // Listen for scroll events
    window.addEventListener('scroll', this.handleScroll);
    // Initial check when the component mounts
    this.handleScroll();
  },
  methods: {
    // Method to handle screen size changes
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    // Method to dynamically generate the image source based on screen size
    getImageSource(imageName, filepath) {
      return `/static/${filepath}/${this.screenSize}/${imageName}`;
    },
    handleScroll() {
      const catElemet = this.$el.querySelector('.animate-cat-on-scroll');

      const catRect = catElemet.getBoundingClientRect();
      const catInViewport =
        catRect.top <= window.innerHeight && catRect.bottom >= 0;

      if (catInViewport) {
        catElemet.classList.add('animate');
      }
    },
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);

    // Remove event listener when component is destroyed
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
